import type { GetRequestMyFilesResponse } from "@nlc/shared-types";
import type { DefaultError, UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import authenticatedApi from "@/lib/api/client";

/** Existing request attachment a new upload can be versioned against. */
export interface VersionableMyFile {
  id: number;
  isSourceFile: boolean;
  name: string;
  version: number | undefined;
}

/**
 * The request's existing "my files", shaped for the versioning combobox and for
 * auto-detecting a previous version when files are added. Shared by the name
 * combobox and both upload hooks so they read from a single cache — mirrors the
 * my-files modal's `useGetRequestMyFiles`.
 */
export function useConfidenceCheckerMyFiles(
  requestId: number,
): UseQueryResult<VersionableMyFile[], DefaultError> {
  return useQuery<GetRequestMyFilesResponse, DefaultError, VersionableMyFile[]>(
    {
      enabled: requestId > 0,
      queryFn: (): Promise<GetRequestMyFilesResponse> =>
        authenticatedApi.url(`/requests/${requestId}/my-files`).get().json(),
      queryKey: ["myFiles", requestId, "confidence-checker"],
      select: (data) =>
        data.myFiles.map((file) => ({
          id: file.attachmentId,
          isSourceFile: file.isSourceFile,
          name: file.name,
          version: file.version,
        })),
    },
  );
}
